const menu = [
  {
    path: '/',
    title: 'Dashboard',
    icon: 'mdi-home',
  },
  {
    path: '/calendar/filter',
    title: 'Agendar',
    icon: 'mdi-calendar-account',
  },
  {
    title: 'Cadastro',
    icon: 'mdi-account-outline',
    active: false,
    items: [
      {
        path: '/patient/cadastre',
        title: 'Dados Pessoais',
        icon: 'mdi-text-box-check-outline',
      },
      {
        path: '/dependents/list',
        title: 'Dependentes',
        icon: 'mdi-account-multiple-plus-outline',
      },
      {
        path: '/covenants/list',
        title: 'Convênios',
        icon: 'mdi-card-account-details-outline',
      },
      {
        path: '/addresses/list',
        title: 'Endereços',
        icon: 'mdi-map-marker',
      },
    ],
  },
  {
    path: '/my-schedule/list',
    title: 'Minha Agenda',
    icon: 'mdi-calendar-clock',
  },
  {
    path: '/professionals/list',
    title: 'Meus Médicos',
    icon: 'mdi-heart-outline',
  },
];

export default menu;
